export class Currency {
  id?: number
  abbreviation: string
  relativeToBaseUnit: number
}
